<template>
  <c-date-picker
    :value="rangeFrom"
    :limit-from="limitFrom"
    :limit-to="limitTo"
    :bold="isRangeTypeInterval"
    title="с"
    form-group
    form-group-margin-bottom
    width="100px"
    @input="$event? changeRangeFrom($event) : ''"
  />
</template>

<script>
import CDatePicker from '../../../../../../../resources/js/components/ui/CDatePicker'
import { mapGetters, mapActions, mapState } from 'vuex'

/**
 * Input для выбора даты с какого периода показывать отчет.
 */
export default {
  name: 'PeriodRangeFromInput',
  components: {
    CDatePicker
  },
  props: {
    /**
     * Левая граница выбора даты.
     */
    limitFrom: {
      validator (value) {
        return ['object', 'string', 'number'].includes(typeof value) || value === null
      },
      default: null
    },
    /**
     * Правая граница выбора даты.
     */
    limitTo: {
      validator (value) {
        return ['object', 'string', 'number'].includes(typeof value) || value === null
      },
      default: null
    }
  },
  computed: {
    ...mapGetters({
      isRangeTypeInterval: 'seo/positionsFilter/isRangeTypeInterval'
    }),
    ...mapState({
      rangeFrom: state => state.seo.positionsFilter.rangeFrom
    })
  },
  methods: {
    ...mapActions({
      changeRangeFrom: 'seo/positionsFilter/changeRangeFrom'
    })
  }
}
</script>
